import Theme from '../theme';

/**
 * Create the action
 */

const { thunk, request, success, error } = Theme.show((id, fetch) => {
    return fetch.get(`/themes/${id}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
